<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-3 d-flex align-items-center justify-content-between">
      <PageTitle title="Lista de notificações" />
      <b-button
        class="ml-4"
        pill
        variant="primary"
        title="Atualizar"
        :disabled="loading"
        @click="list()"
      >
        <i class="fas fa-sync"></i>
      </b-button>
    </b-col>
    <b-col cols="12" class="mb-5">
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=I16792AFAKM&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=7', 
            title: 'Lista de notificações' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a class="btn btn-success" href="https://api.construp.com.br/assets/Notificações.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
      </b-col>
    <b-col cols="12" class="mb-4">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="fields.startDate"
        :endDate.sync="fields.endDate"
        :limparDados="limpar"
        @click.native="list()"
      />
    </b-col>
    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">Notificações criadas</h3>
      <b-button
        :disabled="whatClerkPermission()"
        pill
        variant="success"
        @click="$router.push({ name: typeRouteById() })"
      >
        <i class="fas fa-plus-circle mr-2"></i>
        Criar notificação
      </b-button>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(updatedDate)="data">
          <span>{{ data.item.updatedAt }}</span>
        </template>
        <template #cell(actions)="data">
          <b-button
            :disabled="whatClerkPermission()"
            class="mr-2"
            variant="primary"
            size="sm"
            title="Editar notificação"
            @click="
              $router.push({
                name: typeRouteById(),
                params: { id: data.item.id },
              })
            "
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            :disabled="whatClerkPermission()"
            variant="danger"
            size="sm"
            title="Excluir notificação"
            @click="deleteNotificationById(data.item.id)"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>
    <VideoManual ref="videoManual"/>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import NOTIFICATION_STATUS from 'Enums/Notification/Status.js';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'ListNotifications',
  mixins: [makeToast],
  components: {
    PageTitle,
    PeriodsFilters,
    VideoManual
  },
  data() {
    return {
      loading: false,
      limpar: false,
      pagination: {
        currentPage: 1,
        itemsPerPage: 15,
        total: 0,
      },
      fields: {
        startDate: '',
        endDate: ''
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'id',
            label: 'Id da notificação',
            sortable: true,
          },
          {
            key: 'title',
            label: 'Título',
            sortable: true,
          },
          {
            key: 'statusText',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'updatedDate',
            label: 'Atualizado em',
            sortable: true,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell",
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.list();
    },
  },
  mounted() {
    this.list();
  },
  methods: {
    ...mapActions('shopkeeper', ['listNotification', 'deleteNotification']),
    list() {
      if (this.loading) return;

      this.loading = true;

      this.listNotification({
        userId: this.userTypeId(),
        itemsPerPage: this.pagination.itemsPerPage,
        currentPage: this.pagination.currentPage,
        startDate: this.fields.startDate,
        endDate: this.fields.endDate
      })
        .then((response) => {
          const { data = [], perPage, total } = response.data.data || {};

          this.pagination.itemsPerPage = perPage || 15;
          this.pagination.total = total || 15;

          this.table.records = this.handleRecords(data || []);
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as notificações',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteNotificationById(notificationId) {
      if (!notificationId) return;

      this.$store.dispatch('startLoader');

      this.deleteNotification({ userId: this.userTypeId(), notificationId })
        .then(() => {
          const index = this.table.records.findIndex(
            (x) => x.id === notificationId
          );

          this.table.records.splice(index, 1);
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao excluir a notificação',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    /**
     * @param {Array} records
     */
    handleRecords(records) {
      if (!records || !records.length) return;

      records.forEach((record) => {
        record.statusText = this.getNotificationStatusText(record.status);
      });

      return records;
    },
    getNotificationStatusText(status) {
      const texts = {
        [NOTIFICATION_STATUS.INACTIVE]: 'Inativo',
        [NOTIFICATION_STATUS.ACTIVE]: 'Ativo',
      };

      return texts[status] || NOTIFICATION_STATUS.INACTIVE;
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    typeRouteById(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? 'balconista-app-salvar-notificacao' : 'lojista-app-salvar-notificacao';
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.NOTIFICACAO);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return true;
        }
      }
      return false;
    }
  },
};
</script>